export default __webpack_public_path__ + "static/media/techWork.1ac7802c.png";